import Icon from '../components/Icon.vue'

Icon.register({"chevron-up":{"width":448,"height":512,"paths":[{"d":"M241 130.5L435.3 324.9C444.7 334.2 444.7 349.4 435.3 358.8L412.6 381.5C403.3 390.8 388.1 390.9 378.7 381.5L224 227.5 69.3 381.5C59.9 390.9 44.7 390.8 35.4 381.5L12.7 358.8C3.3 349.4 3.3 334.2 12.7 324.9L207 130.5C216.4 121.2 231.6 121.2 241 130.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chevron-up.js
// module id = CxVc
// module chunks = 0